module.exports = __webpack_public_path__ + "main/assets/public/social-icons/soundcloud.efef701667283d69.svg";